import type { BotMenu } from "@velizhanin-dev/bot-scenario"
import { apiClient } from "@/shared/api/client"
import type { Revised } from "./keys"
import { scenarioPath } from "./keys"
import type { DraftEntryLink, DraftTag } from "./types"

// --- группы, UTM-метки, меню ---

export const createTag = async (id: string, body: { baseRevision: number; name: string }) =>
	(await apiClient.post<Revised<{ tag: DraftTag }>>(scenarioPath(id, "/tags"), body)).data

export const updateTag = async (
	id: string,
	tagId: string,
	body: { baseRevision: number; name?: string; archived?: boolean },
) =>
	(await apiClient.patch<Revised<{ tag: DraftTag }>>(scenarioPath(id, `/tags/${tagId}`), body)).data

export const archiveTags = async (
	id: string,
	body: { baseRevision: number; tagIds: string[]; archived: boolean },
) =>
	(
		await apiClient.post<Revised<{ tagIds: string[]; archived: boolean }>>(
			scenarioPath(id, "/tags/archive"),
			body,
		)
	).data

export const deleteTag = async (id: string, tagId: string, baseRevision: number) =>
	(
		await apiClient.delete<Revised<{ tagId: string }>>(scenarioPath(id, `/tags/${tagId}`), {
			params: { baseRevision },
		})
	).data

export interface EntryLinkInput {
	code: string
	name: string
	comment?: string | null
	flowId?: string | null
	addTagIds?: string[]
	active?: boolean
}

export const createEntryLink = async (
	id: string,
	body: EntryLinkInput & { baseRevision: number },
) =>
	(
		await apiClient.post<Revised<{ entryLink: DraftEntryLink }>>(
			scenarioPath(id, "/entry-links"),
			body,
		)
	).data

export const updateEntryLink = async (
	id: string,
	linkId: string,
	body: Partial<EntryLinkInput> & { baseRevision: number },
) =>
	(
		await apiClient.patch<Revised<{ entryLink: DraftEntryLink }>>(
			scenarioPath(id, `/entry-links/${linkId}`),
			body,
		)
	).data

export const deleteEntryLink = async (id: string, linkId: string, baseRevision: number) =>
	(
		await apiClient.delete<Revised<{ linkId: string }>>(
			scenarioPath(id, `/entry-links/${linkId}`),
			{
				params: { baseRevision },
			},
		)
	).data

export const putMenu = async (id: string, body: { baseRevision: number; menu: BotMenu | null }) =>
	(await apiClient.put<Revised<{ menu: BotMenu | null }>>(scenarioPath(id, "/menu"), body)).data
